import classNames from 'classnames';
import { observer } from 'mobx-react';
import { Component } from 'react';

import { ShareConfigurationSectionTranslation } from '../../../localization/SiteTranslation';
import HeaderLevel4 from '../../../shared/components/Typography/HeaderLevel4';
import { ConfigurationShareState } from '../../ConfigurationShareState';
import ConfigurationCodeShare from './ConfigurationCodeShare/ConfigurationCodeShare';
import ConfigurationDownload from './ConfigurationDownload/ConfigurationDownload';
import css from './ConfigurationShare.css';
import ConfigurationUrlShare from './ConfigurationUrlShare/ConfigurationUrlShare';
import Ean13CodeShare from './Ean13CodeShare/Ean13CodeShare';

interface ConfigurationShareProps {
  state: ConfigurationShareState;
  isCodeLoading?: boolean;
  isCodeError?: boolean;
  className?: string;
  translation: ShareConfigurationSectionTranslation;
  showDownloads: boolean;
  showEan13Code: boolean;
}

@observer
class ConfigurationShare extends Component<ConfigurationShareProps> {
  public static id = 'configuration-share';

  render() {
    const {
      className,
      translation,
      isCodeLoading,
      isCodeError,
      showDownloads,
      showEan13Code,
      state: {
        absoluteShareUrl,
        code,
        downloadAsPdfCommand,
        downloadZipCommand,
        pdfName,
        zipName,
        ean13CodeState,
        downloadImageCommand,
        downloadImageName,
        downloadImageMode,
      },
    } = this.props;

    return (
      <div id={ConfigurationShare.id} className={classNames(css.ConfigurationShare, className)}>
        <HeaderLevel4 className={css.header}>{translation.title}</HeaderLevel4>
        <ConfigurationCodeShare
          code={code}
          isCodeLoading={isCodeLoading}
          isCodeGenerationError={isCodeError}
          translation={translation.codeShare}
        />
        <ConfigurationUrlShare
          className={css.configurationLink}
          isCodeLoading={isCodeLoading}
          translation={translation}
          url={absoluteShareUrl}
        />
        {showEan13Code && (
          <Ean13CodeShare
            className={css.configurationLink}
            isCodeLoading={isCodeLoading}
            translation={translation.generateBarcode}
            copyButtonTranslation={translation.codeShare.copyCode}
            state={ean13CodeState}
          />
        )}
        {showDownloads && (
          <>
            <ConfigurationDownload
              className={css.downloadButtonContainer}
              downloadCommand={downloadAsPdfCommand}
              filename={pdfName}
              icon="pdf"
              label={translation.downloadAsPdf}
              disabled={isCodeLoading}
            />
            {downloadImageMode === 'zip' && (
              <ConfigurationDownload
                className={classNames(css.downloadButtonContainer, css.downloadZipContainer)}
                downloadCommand={downloadZipCommand}
                filename={zipName}
                icon="zip"
                label={translation.downloadVisualizations}
                disabled={isCodeLoading}
              />
            )}
            {downloadImageMode === 'single' && (
              <ConfigurationDownload
                className={classNames(css.downloadButtonContainer, css.downloadZipContainer)}
                downloadCommand={downloadImageCommand}
                filename={downloadImageName}
                icon="zip" // TODO: add image  icon
                label={translation.downloadSingleVisualization}
                disabled={isCodeLoading}
              />
            )}
          </>
        )}
      </div>
    );
  }
}

export default ConfigurationShare;
